import * as api from "./rolesApi";
import { sortBy } from "lodash";
import { useContext } from "react";
import { RolesContext } from "./RolesProvider";

const useRoleService = () => {
  const { roleStore, dispatch } = useContext(RolesContext);

  async function ensureAuthorizationStoreIsInitialized() {
    if (!roleStore.isInitialized) {
      let roles = await api.getAllRoles();
      roles = sortBy(roles, (i) => i.name);
      dispatch({
        type: "set-roles",
        payload: roles,
      });
    }
  }

  return {
    roleStore,
    ensureAuthorizationStoreIsInitialized,
  };
};

export default useRoleService;
